import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { imgSrc } from "../../lib/api";

export default function LibraryPicker({ open, onClose, library, onSelect, selectedPath }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[90] bg-ink/90 backdrop-blur-sm flex items-center justify-center p-4 md:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
          data-testid="library-picker-modal"
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 20, opacity: 0 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="w-full max-w-4xl max-h-[85vh] overflow-y-auto bg-panel border border-line p-6 md:p-8"
            data-testid="library-picker-panel"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="eyebrow !text-gold/90">Photo Library</p>
                <h3 className="font-display text-2xl md:text-3xl mt-2">Choose an image</h3>
                <p className="font-meta text-[9px] uppercase tracking-[0.25em] text-mute mt-2">
                  {String(library.length).padStart(2, "0")} photos stored
                </p>
              </div>
              <button
                onClick={onClose}
                data-testid="library-picker-close-button"
                aria-label="Close"
                className="p-2 text-mute hover:text-bone transition-colors"
              >
                <X size={20} />
              </button>
            </div>

            {library.length === 0 ? (
              <p className="font-display italic text-xl text-bone/80 mt-10 mb-6 text-center">
                Your library is empty — add photos in the Photo Library section above, then pick them here.
              </p>
            ) : (
              <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
                {library.map((p) => (
                  <button
                    type="button"
                    key={p.id}
                    onClick={() => onSelect(p)}
                    data-testid={`library-pick-${p.id}`}
                    className={`relative border transition-all duration-300 ${
                      selectedPath === p.storage_path
                        ? "border-gold"
                        : "border-line hover:border-gold/50"
                    }`}
                  >
                    <img
                      src={imgSrc(p.storage_path)}
                      alt={p.original_filename || "Library photo"}
                      loading="lazy"
                      decoding="async"
                      className="w-full aspect-square object-cover"
                    />
                    {selectedPath === p.storage_path && (
                      <span className="absolute top-2 right-2 bg-gold text-ink font-meta text-[8px] uppercase tracking-[0.2em] px-2 py-1">
                        Selected
                      </span>
                    )}
                  </button>
                ))}
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
